import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import { fnSave } from "@shared/api/restApi";
import { menuInfo } from "@shared/type/CommonType";
import SearchPanel from "../../../../../widgets/SearchPanel";
import SnTab from "@shared/components/SnTab";
import SnGrid from "@shared/components/Grid/SnGrid";
import { showDialog } from "@widgets/CommonDialog";

interface Props {
  Menuprops: menuInfo;
}

const SN_MAS_SET_REG_005 = forwardRef(({ Menuprops }: Props, ref) => {
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);

  const [columns, setColums] = useState<any[]>([]);
  const [columns2, setColums2] = useState<any[]>([]);
  const [columns3, setColums3] = useState<any[]>([]);

  const [dataSource1, setDataSource1] = useState<any>();
  const [dataSource2, setDataSource2] = useState<any>();
  const [dataSource3, setDataSource3] = useState<any>();

  const gridref1 = useRef<any>(null);
  const gridref2 = useRef<any>(null);
  const gridref3 = useRef<any>(null);
  const searchRef = useRef<any>(null);
  const { userInfo } = global();

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums(rtn.grid.grid1);
        setColums2(rtn.grid.grid2);
        setColums3(rtn.grid.grid3);
      } catch (error) {}
    };
    fetchform();
  }, []);

  const onSearch = async () => {
    try {
      const params = {
        id: "sn_mas_set_reg_005_01",
        params: searchRef.current.getFormdata(),
      };

      setDataSource1([]);
      setDataSource2([]);
      setDataSource3([]);

      const data: any = await fnGetDataSet(params);

      setDataSource1(data[0]);
      setDataSource2(data[1]);
      setDataSource3(data[2]);

      if (data[0] && data[0].length > 0) {
        // 1. 그리드 데이터가 바인딩되었음을 기다림
        await new Promise((resolve) => setTimeout(resolve, 50)); // 비동기 반영 대기 (최적화 가능)

        // 2. 첫 번째 행 선택 및 포커스 설정
        gridref1.current?.selectAndFocusRow(0);
        gridref2.current?.selectAndFocusRow(0);
        gridref3.current?.selectAndFocusRow(0);
      }
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onSave = async () => {
    try {
      gridref1.current.api.stopEditing();
      gridref2.current.api.stopEditing();
      gridref3.current.api.stopEditing();

      const SaveData1 = gridref1.current?.getChange();
      const SaveData2 = gridref2.current?.getChange();
      const SaveData3 = gridref3.current?.getChange();

      if (
        SaveData1.modifiedRowcount === 0 &&
        SaveData2.modifiedRowcount === 0 &&
        SaveData3.modifiedRowcount === 0
      ) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      const SaveData = {
        sys_dd: SaveData1,
        sys_mmenu: SaveData2,
        sys_msg: SaveData3,
      };

      await fnSave("SN_MAS_SET_REG_005_SAVE_01", SaveData);

      gridref1.current?.resetUpdate();
      gridref2.current?.resetUpdate();
      gridref3.current?.resetUpdate();
    } catch (error: any) {}
  };

  useImperativeHandle(ref, () => ({
    onSearch,
    onSave,
  }));

  return (
    <>
      <div>
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>

      <div className="h-full flex flex-col">
        <SnTab
          titles={["화면", "메뉴", "메시지"]}
          width={"100%"}
          body={[
            <SnGrid
              ref={gridref1}
              isEditable={true}
              rowSelection="single"
              columnConfig={columns}
              rowData={dataSource1}
            />,
            <SnGrid
              ref={gridref2}
              isEditable={true}
              rowSelection="single"
              columnConfig={columns2}
              rowData={dataSource2}
            />,
            <SnGrid
              ref={gridref3}
              isEditable={true}
              rowSelection="single"
              columnConfig={columns3}
              rowData={dataSource3}
            />,
          ]}
        />
      </div>
    </>
  );
});

export default SN_MAS_SET_REG_005;
